"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectResponseModelTargetAudience = void 0;
exports.ProjectResponseModelTargetAudience = {
    Children: "children",
    YoungAdult: "young adult",
    Adult: "adult",
    AllAges: "all ages",
};
